import { render } from "./BlogSection.vue?vue&type=template&id=61b00e5a&scoped=true"
import script from "./BlogSection.vue?vue&type=script&lang=js"
export * from "./BlogSection.vue?vue&type=script&lang=js"

import "./BlogSection.vue?vue&type=style&index=0&id=61b00e5a&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b00e5a"]])

export default __exports__